export default {
  changeEscSearchIcon(state, payload) {
    state.escSearchIcon = payload;
  }
};



// WEBPACK FOOTER //
// ./src/store/config/mutations.js